export const SET_APP_VERSION = 'SET_APP_VERSION';

export const setAppVersion = version => ({
    type: SET_APP_VERSION,
    payload: version
});
